// extracted by mini-css-extract-plugin
export var optionGrid = "_2x-7";
export var optionList = "_2x-6";
export var questionsBlock = "_2x-9";
export var spacer = "_2x-5";
export var stepCenteredContent = "_2x-3";
export var stepInner = "_2x-0";
export var stepInnerFullWidth = "_2x-1";
export var stepInnerLockScroll = "_2x-2";
export var stepTransitionFrame = "_2x-4";
export var welcomeBlock = "_2x-8";